module.exports = __webpack_public_path__ + "static/img/beiqi-2.ee7ad99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/beiqi-2.png
// module id = 162
// module chunks = 1